import { AlertCircle, MailCheck, X } from 'lucide-react'
import { cn } from '@/lib/cn'
import styles from './AuthNotice.module.scss'

export type NoticeKind = 'error' | 'info'

export interface Notice {
  kind: NoticeKind
  title: string
  message: string
}

interface AuthNoticeProps {
  notice: Notice
  onClose: () => void
}

/**
 * Inline alert used across auth screens (login, signup, password reset).
 * `error` variant uses danger palette + AlertCircle + role="alert" (SR
 * announces immediately). `info` uses info palette + MailCheck + role="status"
 * (announced politely, doesn't interrupt typing).
 */
export function AuthNotice({ notice, onClose }: AuthNoticeProps) {
  const isInfo = notice.kind === 'info'
  return (
    <div
      className={cn(styles.alert, isInfo && styles.alertInfo)}
      role={isInfo ? 'status' : 'alert'}
    >
      {isInfo ? <MailCheck aria-hidden /> : <AlertCircle aria-hidden />}
      <div className={styles.alertBody}>
        <div className={styles.alertTitle}>{notice.title}</div>
        <div className={styles.alertMsg}>{notice.message}</div>
      </div>
      <button
        type="button"
        className={styles.alertClose}
        onClick={onClose}
        aria-label="Fechar alerta"
      >
        <X />
      </button>
    </div>
  )
}
